import { render, staticRenderFns } from "./novice.vue?vue&type=template&id=05451797&scoped=true&"
import script from "./novice.vue?vue&type=script&lang=js&"
export * from "./novice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05451797",
  null
  
)

export default component.exports